<div class="website-content" style="max-width:72rem;padding:0 var(--wa-spacing-x-large) var(--wa-spacing-x-large) var(--wa-spacing-x-large);">
	<div class="wa-stack wa-gap-xl">
		<wa-button [routerLink]="['/plugins']" appearance="plain" variant="neutral">Back to Plugins</wa-button>
		<wa-card appearance="outlined">
			<div class="wa-stack wa-gap-m">
				<div class="wa-stack wa-gap-s">
					<h1 waHeading="xl" waText>AG Grid Enterprise</h1>
					<p waBody="m" waText>Enterprise grid features &mdash; integrated charting, row grouping, server-side row model, pivot tables, range selection, clipboard, Excel export, and status bar, extending the community AG Grid plugin. 8 focused feature modules with &#64;JsonUnwrapped pattern for strongly-typed options.</p>
					<div class="wa-cluster wa-gap-xs">
						<wa-tag pill variant="neutral">Java 25+</wa-tag>
						<wa-tag pill variant="neutral">AG Grid Enterprise 35.0.0</wa-tag>
						<wa-tag pill variant="neutral">AG Charts 13.0.0</wa-tag>
						<wa-tag pill variant="neutral">Angular 21</wa-tag>
						<wa-tag pill variant="neutral">JPMS Modular</wa-tag>
						<wa-tag pill variant="warning">License Required</wa-tag>
					</div>
					<p waBody="s" waColorText="warning" waText>AG Grid Enterprise requires a commercial license. 30-day evaluation available from ag-grid.com/license-pricing/</p>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>COORDINATES &amp; MODULE</div>
					<p waBody="s" waText>Maven: com.jwebmp.plugins:aggrid-enterprise</p>
					<p waBody="s" waText>JPMS Module: com.jwebmp.plugins.aggridenterprise</p>
					<p waBody="s" waText>Built on: AG Grid Enterprise 35.0.0</p>
				</div>
				<wa-details summary="Installation">
					<div class="wa-stack wa-gap-xs">
						@if (!useGradle) {
							<div class="code-block-wrapper">
								<div class="code-block-label" waCaption="s" waFontWeight="semibold" waText>Maven</div>
								<markdown [data]="mdContent_507" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
							</div>
						}
						@if (useGradle) {
							<div class="code-block-wrapper">
								<div class="code-block-label" waCaption="s" waFontWeight="semibold" waText>Gradle &#40;Kotlin DSL&#41;</div>
								<markdown [data]="mdContent_508" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
							</div>
						}
					</div>
				</wa-details>
				<wa-details summary="NPM Dependencies (auto-included)">
					<markdown [data]="mdContent_509" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
				</wa-details>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-m">
					<h2 waHeading="l" waText>Components &#40;2&#41;</h2>
					<p waBody="m" waText>Click any component to see its full API &mdash; properties, constructors, methods, events, slots, and examples.</p>
					<div class="wa-grid wa-gap-s" style="--min-column-size:18rem;">
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>AgGridEnterpriseOptions</h4>
								<p waBody="s" waColorText="quiet" waText>Enterprise grid options extending AgGridOptions with 8 modular enterprise feature modules &mdash; charts, SSRM, aggregation, pivoting, advanced filtering, sidebar/statusbar, range selection, and row grouping</p>
								<div class="wa-cluster wa-gap-xs">
									<wa-tag pill variant="brand">8 props</wa-tag>
									<wa-tag pill variant="neutral">8 methods</wa-tag>
									<wa-tag pill variant="success">3 examples</wa-tag>
								</div>
								<wa-button [routerLink]="['/plugins/aggrid-enterprise/ag-grid-enterprise-options']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>AgGridEnterpriseColumnDef</h4>
								<p waBody="s" waColorText="quiet" waText>Enterprise column definition extending AgGridColumnDef with aggregation, grouping, pivot, and cell data type properties</p>
								<div class="wa-cluster wa-gap-xs">
									<wa-tag pill variant="brand">16 props</wa-tag>
									<wa-tag pill variant="neutral">13 methods</wa-tag>
									<wa-tag pill variant="success">3 examples</wa-tag>
								</div>
								<wa-button [routerLink]="['/plugins/aggrid-enterprise/ag-grid-enterprise-column-def']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
							</div>
						</wa-card>
					</div>
				</div>
				<wa-details summary="Features (12)">
					<div class="wa-stack wa-gap-xs">
						<p waBody="s" waColorText="quiet" waText>Integrated charts &mdash; render charts directly from grid data with configurable themes</p>
						<p waBody="s" waColorText="quiet" waText>Server-side row model &mdash; lazy-load millions of rows with backend pagination</p>
						<p waBody="s" waColorText="quiet" waText>Row grouping &mdash; group by multiple columns, custom hierarchies, expandable groups</p>
						<p waBody="s" waColorText="quiet" waText>Pivot tables &mdash; row and column pivots with value aggregation</p>
						<p waBody="s" waColorText="quiet" waText>Range selection &mdash; select and copy cell ranges, Excel-like behavior</p>
						<p waBody="s" waColorText="quiet" waText>Excel export &mdash; export with styles, formulas, and formatting</p>
						<p waBody="s" waColorText="quiet" waText>Side bar &mdash; columns and filters panels with user toggle</p>
						<p waBody="s" waColorText="quiet" waText>Status bar &mdash; row count, selection count, aggregation metrics</p>
						<p waBody="s" waColorText="quiet" waText>Advanced filtering &mdash; filter builder UI with complex expressions</p>
						<p waBody="s" waColorText="quiet" waText>Row numbers &mdash; official AG Grid row numbering with helper method</p>
						<p waBody="s" waColorText="quiet" waText>AllEnterpriseModule auto-registered via PageConfigurator</p>
						<p waBody="s" waColorText="quiet" waText>8 focused feature modules with &#64;JsonUnwrapped pattern</p>
					</div>
				</wa-details>
				<wa-divider></wa-divider>
				<wa-details open summary="Examples (1)">
					<div class="wa-stack wa-gap-m">
						<div class="wa-stack wa-gap-xs">
							<h4 waHeading="s" waText>Enterprise Grid Setup</h4>
							<p waBody="s" waColorText="quiet" waText>Set license key and configure enterprise features.</p>
							<markdown [data]="mdContent_510" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
						</div>
					</div>
				</wa-details>
				<wa-details open summary="Quick Start">
					<markdown [data]="mdContent_511" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
				</wa-details>
				<wa-divider></wa-divider>
				<wa-details open summary="SPI Extension Point Details (1)">
					<div class="wa-stack wa-gap-s">
						<div class="wa-stack wa-gap-xs">
							<div class="wa-cluster wa-gap-xs">
								<wa-tag pill variant="success">IPageConfigurator</wa-tag>
								<wa-tag pill variant="neutral">provides</wa-tag>
							</div>
							<p waBody="s" waColorText="quiet" waText>AgGridEnterprisePageConfigurator auto-registers AllEnterpriseModule, license key, and enterprise CSS/JS</p>
						</div>
					</div>
				</wa-details>
				<wa-details open summary="SPI Extension Points">
					<div class="wa-stack wa-gap-xs">
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="success">provides IPageConfigurator</wa-tag>
						</div>
					</div>
				</wa-details>
				<wa-divider></wa-divider>
				<wa-details open summary="Properties (1)">
					<table style="border-collapse:collapse;width:100%;">
						<thead>
							<tr style="border-bottom:2px solid var(--wa-color-neutral-200);">
								<th style="color:var(--wa-color-text-quiet);font-size:var(--wa-font-size-xs);font-weight:var(--wa-font-weight-semibold);padding:var(--wa-spacing-small);text-align:left;">Property</th>
								<th style="color:var(--wa-color-text-quiet);font-size:var(--wa-font-size-xs);font-weight:var(--wa-font-weight-semibold);padding:var(--wa-spacing-small);text-align:left;">Type</th>
								<th style="color:var(--wa-color-text-quiet);font-size:var(--wa-font-size-xs);font-weight:var(--wa-font-weight-semibold);padding:var(--wa-spacing-small);text-align:left;">Default</th>
								<th style="color:var(--wa-color-text-quiet);font-size:var(--wa-font-size-xs);font-weight:var(--wa-font-weight-semibold);padding:var(--wa-spacing-small);text-align:left;">Description</th>
							</tr>
						</thead>
						<tbody>
							<tr style="border-bottom:1px solid var(--wa-color-neutral-100);">
								<td style="color:var(--wa-color-brand-normal);font-family:var(--wa-font-mono);font-size:var(--wa-font-size-xs);font-weight:var(--wa-font-weight-semibold);padding:var(--wa-spacing-small);">AG_GRID_LICENSE_KEY</td>
								<td style="color:var(--wa-color-text-quiet);font-family:var(--wa-font-mono);font-size:var(--wa-font-size-xs);padding:var(--wa-spacing-small);">String</td>
								<td style="color:var(--wa-color-text-quiet);font-family:var(--wa-font-mono);font-size:var(--wa-font-size-xs);padding:var(--wa-spacing-small);">–</td>
								<td style="font-size:var(--wa-font-size-s);padding:var(--wa-spacing-small);">AG Grid Enterprise license key — set via AgGridEnterprisePageConfigurator.setAG_GRID_LICENSE_KEY()</td>
							</tr>
						</tbody>
					</table>
				</wa-details>
				<wa-details open summary="Prerequisites">
					<div class="wa-cluster wa-gap-xs">
						<wa-tag pill variant="neutral">Java 25 LTS</wa-tag>
						<wa-tag pill variant="neutral">Maven 3.9+</wa-tag>
						<wa-tag pill variant="neutral">Node.js 18+</wa-tag>
						<wa-tag pill variant="neutral">Angular 21+</wa-tag>
					</div>
				</wa-details>
				<wa-divider></wa-divider>
				<div class="wa-cluster wa-gap-s">
					<wa-tag pill variant="neutral">Upstream: https://www.ag-grid.com/</wa-tag>
					<wa-tag pill variant="neutral">Docs: https://www.ag-grid.com/documentation/</wa-tag>
					<wa-tag pill variant="neutral">Source: https://github.com/JWebMP/AgGridEnterprise</wa-tag>
				</div>
			</div>
		</wa-card>
	</div>
</div>